'use client';
import Image from 'next/image';
const speakers = [
  {
    name: "Frederico Kessler",
    designation: "CPO/Partner",
    company: "Funfair Ventures",
    imageSrc: "/images/speakers/frederico.webp",
    alt: "frederico",
  },
  {
    name: "Raiford C Cockfield III",
    designation: "CEO / Founder ",
    company: "Good Game Group INC + Creator of the Good Game Global Reality TV Series",
    imageSrc: "/images/speakers/rai-cockfield.webp",
    alt: "rai-cockfield",
  },
  {
    name: "Nick Samarin",
    designation: "CEO",
    company: "OneWayBlock",
    imageSrc: "/images/speakers/nick-samarin.webp",
    alt: "nick-samarin",
  },
  {
    name: "Karn	Chakerverty",
    designation: "Founder & CEO",
    company: "Kult Games",
    imageSrc: "/images/speakers/karn-chakerverty-img.webp",
    alt: "karn-chakerverty",
  },

  {
    name: "Michael Harding",
    designation: "Director",
    company: " Foundation Ventures Group",
    imageSrc: "/images/speakers/michael-harding.webp",
    alt: "michael-harding",
  },

   {
    name: "Paul Shikhaleev",
    designation: "Head of Sales and Partnership Operations",
    company: "Cointelegraph",
    imageSrc: "/images/speakers/paul-shikhaleev.webp",
    alt: "paul-shikhaleev",
  },
  // end of 2025 speakers
   {
    name: "Sébastien Borget",
    designation: "Co-founder",
    company: "The Sandbox ",
    imageSrc: "/images/speakers/sebastien-borget-pic.webp",
    alt: "sebastien-borget",
  },
  {
    name: "Andy",
    designation: "CCO",
    company: "YOM.net",
    imageSrc: "/images/speakers/andy.webp",
    alt: "Andy",
  },
  {
    name: "Flavien Defraire",
    designation: "Director of Global Development",
    company: "Blockchain Gaming Alliance",
    imageSrc: "/images/speakers/flavien-defraire.webp",
    alt: "Flavien-Defraire",
  },
   {
    name: "Kevin Soltani",
    designation: "CEO",
    company: "Gima Group",
    imageSrc: "/images/speakers/kevin-soltani.webp",
    alt: "Kevin-Soltani",
  },
   {
    name: "Mariano Rubinstein",
    designation: "CEO & Co-founder",
    company: "Sura Gaming & Sura Ventures",
    imageSrc: "/images/speakers/mariano-rubinstein.webp",
    alt: "mariano-rubinstein",
  },
    {
    name: "Mihee Park",
    designation: "CFO",
    company: "OL Ltd. (formerly known as Big Time Studios Ltd.) ",
    imageSrc: "/images/speakers/mihee-park.webp",
    alt: "Mihee-Park",
  },
   {
    name: "Ryuzaki",
    designation: "Ambassador, DAO Council Member",
    company: "YOM.net ",
    imageSrc: "/images/speakers/ryuzaki.webp",
    alt: "Ryuzaki",
  },
 
];
const SpeakerSection = () => {
  return (
    <section data-component-id="src/app/SpeakersSection.tsx:102:4" data-component-path="src/app/SpeakersSection.tsx" data-component-line="102" data-component-end-line="152" data-component-file="SpeakersSection.tsx" data-component-name="section" data-component-content="%7B%22elementName%22%3A%22section%22%2C%22id%22%3A%22speakers%22%2C%22className%22%3A%22w-full%20bg-White%20p-6%20sm%3Ap-8%20md%3Ap-10%20lg%3Ap-%5B38px%5D%20sm%3Ap-4%22%7D" id='speakers'
      className="w-full bg-White p-6 sm:p-8 md:p-10 lg:p-[38px] sm:p-4"
    >
      <div data-component-id="src/app/SpeakersSection.tsx:105:6" data-component-path="src/app/SpeakersSection.tsx" data-component-line="105" data-component-end-line="151" data-component-file="SpeakersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20max-w-%5B1100px%5D%20mx-auto%22%7D" className="w-full max-w-[1100px] mx-auto">
        {/* Section Title */}
         <h2 data-component-id="src/app/SpeakersSection.tsx:107:9" data-component-path="src/app/SpeakersSection.tsx" data-component-line="107" data-component-end-line="109" data-component-file="SpeakersSection.tsx" data-component-name="h2" data-component-content="%7B%22elementName%22%3A%22h2%22%2C%22className%22%3A%22font-Gotham%20text-center%20mb-20%20font-bold%20text-%5B20px%5D%20sm%3Atext-%5B26px%5D%20md%3Atext-%5B32px%5D%20leading-%5B24px%5D%20sm%3Aleading-%5B31px%5D%20md%3Aleading-%5B39px%5D%20text-text-primary%22%2C%22textContent%22%3A%22Past%20Speakers%22%7D" className="font-Gotham text-center mb-20 font-bold text-[20px] sm:text-[26px] md:text-[32px] leading-[24px] sm:leading-[31px] md:leading-[39px] text-text-primary">
          Past Speakers
         </h2>
        {/* Speaker List Box */}
        <div data-component-id="src/app/SpeakersSection.tsx:111:8" data-component-path="src/app/SpeakersSection.tsx" data-component-line="111" data-component-end-line="150" data-component-file="SpeakersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-full%20%20max-w-%5B1230px%5D%20mx-auto%22%7D" className="w-full  max-w-[1230px] mx-auto">
          {/* Mobile gap-5 and larger screens gap-2 */}
          <div data-component-id="src/app/SpeakersSection.tsx:113:10" data-component-path="src/app/SpeakersSection.tsx" data-component-line="113" data-component-end-line="149" data-component-file="SpeakersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22grid%20grid-cols-2%20sm%3Agrid-cols-2%20md%3Agrid-cols-3%20lg%3Agrid-cols-4%20gap-6%20sm%3Agap-y-10%20sm%3Agap-2%20place-items-center%22%7D" className="grid grid-cols-2 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 sm:gap-y-10 sm:gap-2 place-items-center">
            {speakers.map((speaker, index) => (
              <div data-component-id="src/app/SpeakersSection.tsx:115:14" data-component-path="src/app/SpeakersSection.tsx" data-component-line="115" data-component-end-line="147" data-component-file="SpeakersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22flex%20flex-col%20items-center%22%7D" key={index} className="flex flex-col items-center">
                {/* Adjusted Image Container for smaller mobile sizes */}
                {/* <div className="w-[150px] h-[150px] sm:w-[250px] sm:h-[250px] relative mb-4">
                  <Image
                    src={speaker.imageSrc}
                    alt={speaker.alt}
                    height={200}
                    width={200}              
                    objectFit="cover"
                    className="rounded-full"
                    unoptimized
                  />
                </div> */}
                <div data-component-id="src/app/SpeakersSection.tsx:128:16" data-component-path="src/app/SpeakersSection.tsx" data-component-line="128" data-component-end-line="137" data-component-file="SpeakersSection.tsx" data-component-name="div" data-component-content="%7B%22elementName%22%3A%22div%22%2C%22className%22%3A%22w-%5B150px%5D%20h-%5B150px%5D%20sm%3Aw-%5B220px%5D%20sm%3Ah-%5B220px%5D%20relative%20mb-4%22%7D" className="w-[150px] h-[150px] sm:w-[220px] sm:h-[220px] relative mb-4">
  <Image data-component-id="src/app/SpeakersSection.tsx:129:2" data-component-path="src/app/SpeakersSection.tsx" data-component-line="129" data-component-end-line="136" data-component-file="SpeakersSection.tsx" data-component-name="Image" data-component-content="%7B%22elementName%22%3A%22Image%22%2C%22className%22%3A%22rounded-full%20object-cover%22%7D"
    src={speaker.imageSrc}
    alt={speaker.alt}
    fill
    className="rounded-full object-cover"
    sizes="(max-width: 640px) 150px, 220px"
    unoptimized
  />
</div>
                <h3 data-component-id="src/app/SpeakersSection.tsx:138:16" data-component-path="src/app/SpeakersSection.tsx" data-component-line="138" data-component-end-line="140" data-component-file="SpeakersSection.tsx" data-component-name="h3" data-component-content="%7B%22elementName%22%3A%22h3%22%2C%22className%22%3A%22text-%5B%23fff%5D%20text-%5B16px%5D%20sm%3Atext-%5B18px%5D%20font-semibold%20text-center%20mb-1%22%7D" className="text-[#fff] text-[16px] sm:text-[18px] font-semibold text-center mb-1">
                  {speaker.name}
                </h3>
                <p data-component-id="src/app/SpeakersSection.tsx:141:16" data-component-path="src/app/SpeakersSection.tsx" data-component-line="141" data-component-end-line="143" data-component-file="SpeakersSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-white%20text-%5B12px%5D%20sm%3Atext-%5B14px%5D%20text-center%20mb-1%22%7D" className="text-white text-[12px] sm:text-[14px] text-center mb-1">
                  {speaker.designation}
                </p>
                <p data-component-id="src/app/SpeakersSection.tsx:144:16" data-component-path="src/app/SpeakersSection.tsx" data-component-line="144" data-component-end-line="146" data-component-file="SpeakersSection.tsx" data-component-name="p" data-component-content="%7B%22elementName%22%3A%22p%22%2C%22className%22%3A%22text-white%20text-%5B10px%5D%20sm%3Atext-%5B12px%5D%20text-center%22%7D" className="text-white text-[10px] sm:text-[12px] text-center">
                  {speaker.company}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
    
  );
};
export default SpeakerSection;






